define('fukit/behavior/select.list.item.from.state.id.attribute.behavior',['require','exports','module','marionette','backbone','backbone.radio'],function(require, exports, module) {
  //prettier-ignore
  var Mn       = require('marionette'),
      Backbone = require('backbone'),
      Radio    = require('backbone.radio');

  var SelectListItemFromStateIdAttributeBehavior = Mn.Behavior.extend({
    defaults: {
      stateIdAttribute: 'id',
    },

    collectionEvents: {
      sync: 'onCollectionSync',
    },

    initialize: function() {
      Mn.Behavior.prototype.initialize.apply(this, arguments);

      this.once('before:render', this.onFirstBeforeRender, this);
    },

    onFirstBeforeRender: function() {
      this.updateSelectedId();
    },

    updateSelectedId: function() {
      var state = Radio.channel('AppKit.controllerService').request('state');
      if (state) {
        if (state.has(this.getOption('stateIdAttribute'))) {
          this.selectedId = state.get(this.getOption('stateIdAttribute'));
          this.updateValue();
        }
      }
    },

    onChangeValue: function() {
      if (this.view.value instanceof Backbone.Model) {
        this.selectedId = this.view.value.id;
      }
    },

    onCollectionSync: function() {
      this.updateValue();
    },

    updateValue: function() {
      var model = null;
      if (this.view.collection) {
        model = this.view.collection.get(this.selectedId);
      }
      this.view.value = model;
    },
  });

  module.exports = SelectListItemFromStateIdAttributeBehavior;
});

